import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router';
import useData from '../hooks/useData';
import Navigation from '../Navigation/Navigation';
import './Details.css';
import Slider from "react-slick";
import { Link } from 'react-router-dom';

const Details = () => {
    const { id } = useParams();
    const { projects } = useData();
    const project = projects?.find(project => project.id === id);
    console.log(project);
    var settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: true
    };
    // { id, img1, livelink, githubclient, githubserver, title, description, technology, overview, }
    return (
        <>
            <Navigation />
            <div className="details">
                <Container>
                    <div className="py-4">
                        <Slider {...settings}>
                            <div>
                                <img width="100%" height="450px" src={project?.img1} alt="website" />
                            </div>
                            <div>
                                <img width="100%" height="450px" src={project?.img2} alt="website" />
                            </div>
                            <div>
                                <img width="100%" height="450px" src={project?.img2} alt="website" />
                            </div>
                            <div>
                                <img width="100%" height="450px" src={project?.img4} alt="website" />
                            </div>
                        </Slider>
                    </div>
                    <div className="py-4">
                        <div className="">
                            <h1 className="text-bolder text-white">
                                {project?.title}
                            </h1>
                        </div>
                        <div className="my-5">
                            <a href={project?.livelink} target="_blank">
                                <Button variant="outline-info"
                                    className="me-5 px-5 py-3">
                                    LIVE SITE LINK
                                </Button>
                            </a>
                            <a href={project?.githubclient} target="_blank">
                                <Button variant="outline-info"
                                    className="mx-5 px-5 py-3">
                                    GITHUB CLIENT
                                </Button>
                            </a>
                            <a href={project?.githubserver} target="_blank">
                                <Button variant="outline-info"
                                    className="ms-5 px-5 py-3">
                                    GITHUB SERVER
                                </Button>
                            </a>
                        </div>
                        <div className="fs-5 px-5 textcolor">
                            {project?.description}
                        </div>
                        <Row className="text-white px-5 g-5">
                            <Col sm={12} md={5} lg={5}>
                                <h2 className="text-bolder my-5">
                                    Technology Used
                                </h2>
                                <p className="fs-5 text-start">
                                    {project?.technology}
                                </p>
                            </Col>
                            <Col sm={12} md={7} lg={7}>
                                <h2 className="text-bolder my-5">
                                    The feature of the website
                                </h2>
                                <ul className="text-start fs-5 textcolor">
                                    <li>{project?.overview?.a}</li>
                                    <li>{project?.overview?.b}</li>
                                    <li>{project?.overview?.c}</li>
                                    <li>{project?.overview?.d}</li>
                                    <li>{project?.overview?.e}</li>
                                    <li>{project?.overview?.f}</li>
                                </ul>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default Details;